var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_38404)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_38404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3412 14.0321H34.3902L23.9582 44.8795C23.9049 45.0371 23.8273 45.1854 23.7281 45.3191C23.6292 45.4529 23.5099 45.5702 23.3745 45.6671C23.2391 45.7641 23.0896 45.8395 22.9309 45.8903C22.7721 45.9411 22.6065 45.9674 22.4401 45.9674H14.6195C14.3656 45.9674 14.1151 45.9072 13.8893 45.7912C13.6632 45.6755 13.468 45.5077 13.32 45.3017C13.1718 45.0957 13.0749 44.8575 13.0372 44.6068C12.9995 44.3562 13.0224 44.1 13.1035 43.8599L22.8226 15.1191C22.8757 14.9615 22.9534 14.8133 23.0527 14.6795C23.1516 14.5457 23.2713 14.4284 23.4063 14.3315C23.5418 14.2345 23.6912 14.1591 23.85 14.1083C24.0088 14.0575 24.1743 14.0312 24.3407 14.0312V14.0317L24.3412 14.0321Z",
    fill: "url(#paint0_linear_1322_38404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8669 45.967H33.8436C33.7429 45.967 33.6423 45.9577 33.543 45.9387C33.4441 45.92 33.3469 45.8921 33.253 45.8553C33.1592 45.8184 33.0692 45.7727 32.9839 45.7193C32.8987 45.6656 32.8187 45.6041 32.7449 45.5356L22.5053 35.9972C22.397 35.8963 22.3215 35.7653 22.2888 35.6212C22.256 35.477 22.2675 35.3264 22.3218 35.1889C22.3761 35.0513 22.4707 34.9333 22.5931 34.8501C22.7158 34.7671 22.8606 34.7227 23.0088 34.7227H38.9438L42.8661 45.9675L42.8669 45.967Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4263 14.0332L27.3919 34.7262L38.8856 34.7237L42.8282 45.9685H33.8388C33.7458 45.9676 33.6528 45.9592 33.5611 45.9426C33.4695 45.9261 33.3795 45.902 33.292 45.8698C33.1166 45.8061 32.9535 45.7128 32.8097 45.5942L25.8976 39.1596L23.9626 44.8514C23.9125 44.9937 23.8437 45.1288 23.7579 45.2529C23.5861 45.5025 23.351 45.7022 23.0766 45.8317C22.94 45.8962 22.7953 45.9422 22.6465 45.9685H14.6242C14.3678 45.9693 14.1148 45.9084 13.8868 45.7906C13.6588 45.673 13.4625 45.5024 13.3146 45.2931C13.1667 45.0839 13.0714 44.8422 13.0369 44.5885C13.0025 44.3347 13.0297 44.0763 13.1163 43.8352L22.8197 15.1418C22.8703 14.9813 22.9462 14.8301 23.0447 14.6938C23.1428 14.5574 23.2625 14.4372 23.3984 14.3381C23.5342 14.239 23.6853 14.1619 23.8454 14.1103C24.0054 14.0586 24.1731 14.0324 24.3417 14.0332H34.4268H34.4263Z",
    fill: "url(#paint1_linear_1322_38404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8957 43.861C46.9768 44.1012 46.9997 44.3572 46.9623 44.608C46.9246 44.8586 46.8279 45.0967 46.68 45.3028C46.5319 45.5087 46.3369 45.6764 46.1109 45.7922C45.8849 45.9079 45.6346 45.9684 45.3805 45.9685H34.1806C34.4345 45.9685 34.685 45.9079 34.9113 45.7923C35.1371 45.6767 35.3324 45.5086 35.4805 45.3028C35.6287 45.097 35.7255 44.8586 35.7633 44.608C35.8011 44.3573 35.7781 44.1011 35.6971 43.861L25.9775 15.1193C25.8705 14.8027 25.6666 14.5275 25.3946 14.3326C25.2596 14.2356 25.1102 14.1607 24.9518 14.1098C24.7935 14.059 24.6279 14.0332 24.4619 14.0332H35.6614C35.8278 14.0332 35.9929 14.059 36.1517 14.1098C36.3101 14.1607 36.4595 14.236 36.5949 14.3326C36.7299 14.4295 36.8492 14.5468 36.9481 14.6802C37.0471 14.8136 37.1243 14.9618 37.1778 15.1193L46.8974 43.861H46.8957Z",
    fill: "url(#paint2_linear_1322_38404)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1322_38404",
    x1: 28.0087,
    y1: 16.3991,
    x2: 17.6134,
    y2: 47.1866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1322_38404",
    x1: 31.2649,
    y1: 30.7378,
    x2: 28.8506,
    y2: 31.5589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1322_38404",
    x1: 29.932,
    y1: 15.5025,
    x2: 41.3426,
    y2: 45.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_38404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_38404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 32,
    fill: "white",
    transform: "translate(13 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow14);
export default __webpack_public_path__ + "static/media/row-1-4.5652258fb0ec7bcdffbb88efc3b2ea03.svg";
export { ForwardRef as ReactComponent };